import { CivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import {
  Expertise,
  ExpertiseState,
  expertType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { IdMapType } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/typings';
import { get, isEmpty, isNil } from 'lodash';
import { VictimType } from 'typings/globalTypes';

export const getPartiesIds = (parties: { id: number }[]) =>
  parties.map(v => Number(v.id));

export const formatFieldToSave = (
  documents: CivilParty[],
  victims: VictimType[],
  set: Set<number>,
  index: number,
) => {
  const selectedVictims = victims.filter(v => [...set].includes(Number(v.id)));
  documents[index].victims = selectedVictims as any;

  return documents;
};

export const getExpertises = (parties: expertType[]) => {
  return parties.map(v => ({
    victimId: v.id,
    vehiculeId: v.id,
    expertName: get(v, 'expertise.expertName', ''),
    address: get(v, 'expertise.address', ''),
    expertiseDate: get(v, 'expertise.expertiseDate', ''),
  }));
};

const idHelper = { getPartiesIds };

export const formatExpertiseState = (
  expertises: Expertise[],
): ExpertiseState[] => {
  return expertises.map(e => ({
    expertiseId: e.expertiseId,
    expertiseJudgementAddDocumentId: e.expertiseJudgementAddDocumentId,
    vehicules: new Set(idHelper.getPartiesIds(e.vehicules as IdMapType[])),
    victims: new Set(idHelper.getPartiesIds(e.victims as IdMapType[])),
    expertises: new Set(
      getExpertises([
        ...(e.victims as any[]),
        ...(e.vehicules as any[]),
      ]) as any,
    ),
  }));
};
export const extractVictimIdFromJom = (judgementOnMerits: any) => {
  if (!isEmpty(judgementOnMerits)) {
    const deceasedVictims = get(judgementOnMerits, 'beneficiaries', []).map(
      (item: any) => item?.beneficiary?.victimId,
    );
    const jmvBlessedVictims = get(
      judgementOnMerits,
      'judgementOnMerits',
      [],
    ).flatMap((item: any) =>
      get(item, 'jom.jmv', []).map((el: any) => get(el, 'victimId', null)),
    );

    const civjvmBlessedVictims = get(
      judgementOnMerits,
      'judgementOnMerits',
      [],
    ).flatMap((item: any) =>
      get(item, 'jom.civjvm', [])
        .filter(
          (element: any) =>
            !isNil(get(element, 'expertiseJudgementAddDocumentId', null)),
        )
        .map((el: any) => get(el, 'victimId', null)),
    );

    const civjsBlessedVictims = get(
      judgementOnMerits,
      'judgementOnMerits',
      [],
    ).flatMap((item: any) =>
      get(item, 'jom.civjs', []).map((el: any) => get(el, 'victimId', null)),
    );

    return [
      ...deceasedVictims,
      ...jmvBlessedVictims,
      ...civjvmBlessedVictims,
      ...civjsBlessedVictims,
    ].filter((el: any) => !isNil(el));
  } else {
    return [];
  }
};
